import { api } from "./api";
import {
  UOMUnitCreate,
  UOMUnitUpdate,
  UOMUnitFull,
  PaginatedUOMUnitResponse,
} from "../types/uomTypes";
import { ListRequest } from "../types/common/commonTypes";

/**
 * UOM Units Service
 *
 * Manages UOM (Unit of Measure) Units - the actual units within UOM types
 * (e.g., kg, g, lb, oz within Weight type)
 *
 * API Endpoints:
 * - POST /uom-units/ - Create UOM unit
 * - GET /uom-units/ - List UOM units with pagination and filtering
 * - GET /uom-units/{id} - Get UOM unit by ID
 * - PUT /uom-units/{id} - Update UOM unit
 * - DELETE /uom-units/{id} - Delete UOM unit (with base unit handling)
 * - POST /uom-units/{id}/restore - Restore deleted UOM unit
 */
const unit_base = "/inventory/uom/units";
export const uomUnitsService = {
  list: async (params: ListRequest): Promise<PaginatedUOMUnitResponse> => {
    const response = await api.post(`${unit_base}/search`, params);
    return response.data;
  },

  /**
   * Get UOM unit by ID
   * GET /api/v1/uom-units/{id}
   */
  getById: async (id: string): Promise<UOMUnitFull> => {
    const response = await api.get(`${unit_base}/${id}`);
    return response.data;
  },

  /**
   * Create a new UOM unit
   * POST /api/v1/uom-units/
   */
  create: async (data: UOMUnitCreate): Promise<UOMUnitFull> => {
    const response = await api.post(`${unit_base}/`, data);
    return response.data;
  },

  /**
   * Update UOM unit
   * PUT /api/v1/uom-units/{id}
   */
  update: async (id: string, data: UOMUnitUpdate): Promise<UOMUnitFull> => {
    const response = await api.put(`${unit_base}/${id}`, data);
    return response.data;
  },
};
